import Swiper from 'swiper';

const productPage = $('#product').length;
const banner = $('#productBanner');
const gallery = $('#gallerySlider');

export function productsFunc() {
  if (productPage) {
    if (banner) {
      let bannerSwiper, bannerOptions;
      bannerSwiper = undefined;
      bannerOptions = {
        loop: true,
        speed: 800,
        effect: 'slide',
        normalizeSlideIndex: true,
        paginationClickable: true,
        centeredSlides: true,
        slidesPerView: 1,
        navigation: {
          nextEl: '.bannerNext',
          prevEl: '.bannerPrev',
        },
        preloadImages: false,
        lazy: {
          elementClass: 'lazyload',
          loadPrevNextAmount: 2,
          loadPrevNext: true
        }
      };

      function initBannerSwiper() {
        bannerSwiper = new Swiper('#productBanner', bannerOptions);
      }
      initBannerSwiper();
    }
    if (gallery) {
      let gallerySwiper, galleryOptions;
      gallerySwiper = undefined;
      galleryOptions = {
        loop: true,
        speed: 800,
        effect: 'slide',
        normalizeSlideIndex: true,
        paginationClickable: true,
        centeredSlides: true,
        slidesPerView: 1,
        loopAdditionalSlides: 1,
        navigation: {
          nextEl: '.galleryNext',
          prevEl: '.galleryPrev',
        },
        preloadImages: false,
        lazy: {
          elementClass: 'lazyload',
          loadPrevNextAmount: 2,
          loadPrevNext: true
        },
        breakpoints: {
          751: {
            spaceBetween: 60
          },
          320: {
            spaceBetween: 20
          }
        }
      };

      function initGallerySwiper() {
        gallerySwiper = new Swiper('#gallerySlider', galleryOptions);
      }
      initGallerySwiper();
    }
  }
}
